import styled from "styled-components";

export const TestiomentalWrapper = styled.div`
  min-height: 482px;
  background-color: #f5f7fc;
  color: #000;
  padding-top: 48px;
  padding-bottom: 22px;
  position: relative;
`;
